import { Controller } from "@hotwired/stimulus"
import Prism from "prismjs"
import "prismjs/components/prism-markup-templating" // Required for ERB
import "prismjs/components/prism-ruby"
import "prismjs/components/prism-erb"

export default class extends Controller {
    static targets = ["code", "copyButton", "copyText"]

    connect() {
        if (this.hasCodeTarget) {
            Prism.highlightElement(this.codeTarget)
        }
    }

    disconnect() {
        if (this._resetTimer) clearTimeout(this._resetTimer)
    }

    copy() {
        const code = this.codeTarget.textContent || ""
        navigator.clipboard
            .writeText(code)
            .then(() => {
                this.copyTextTarget.textContent = "Copied!"
                this.copyButtonTarget.classList.add("copied")

                this._resetTimer = setTimeout(() => {
                    this.copyTextTarget.textContent = "Copy"
                    this.copyButtonTarget.classList.remove("copied")
                }, 2000)
            })
            .catch((err) => {
                console.error("Failed to copy:", err)
            })
    }
}
